import { isDefined } from './defined';
export const convertToString = (value, forceToString = false) => {
  if (!isDefined(value)) {
    return forceToString ? '' : value;
  }
  return value.toString();
};
export const equalStrings = (string1, string2, forceToString = false) => {
  return convertToString(string1, forceToString) === convertToString(string2, forceToString);
};